export type ImageQuality = 'high-quality' | 'web-friendly'

const ImageQualityMap: Record<ImageQuality, string> = {
  'high-quality': 'hq',
  'web-friendly': 'wf',
}

/**
 * Gets the quality of image for displaying
 *
 * @param url The s3 url to fetch from the bucket
 * @param quality The quality of image to fetch
 * @returns Newly formatted url
 */
export function getImageUrl(url: string, quality: ImageQuality): string {
  return url.replace(
    /((amazonaws.com|cloudfront.net)\/(events|entries))\/([^/]+)/,
    `$1/${ImageQualityMap[quality]}/$4`,
  )
}
